import { render } from "./languageSelector.vue?vue&type=template&id=26523dba&scoped=true&ts=true"
import script from "./languageSelector.vue?vue&type=script&lang=ts"
export * from "./languageSelector.vue?vue&type=script&lang=ts"

import "./languageSelector.vue?vue&type=style&index=0&id=26523dba&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26523dba"]])

export default __exports__